import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from './ConversationModalParticipantsLoader.styled';

const ConversationModalParticipantsLoader = ({ isGroupConversation }) => {
  // For individual conversations, show single loading icon
  if (!isGroupConversation) {
    return <Loader opacity=".6" />;
  }

  // For group conversations, show multiple loading icons
  return (
    <React.Fragment>
      <Loader opacity=".4" />
      <Loader opacity=".6" />
      <Loader opacity=".8" />
    </React.Fragment>
  );
};

ConversationModalParticipantsLoader.propTypes = {
  isGroupConversation: PropTypes.bool.isRequired,
};

export default ConversationModalParticipantsLoader;
